<template>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
</template>
  
<script>
    import navBar from '@/components/ui/navbars/navbar.vue';
  
    export default {
        components: {
            navBar,
        },
    }
</script>  